/** @format */

export interface IHomrBanner {
  altText: string;
  animation?: string;
  dataEMTag: string;
  gif?: string;
  gifMobile?: string;
  headline?: string;
  image: string;
  link: string;
  mobileImg?: string;
  title?: string;
  youtubeId?: string;
}
